import React from 'react';

import Stars from '../../../../../Common/Stars';
import { DivisionIcon, VCIcon } from '../../../../../Common/Buttons/TypeIcons';
import {GridContainer, GridItem} from '../../../../../Common/DesignSystem/Grid';
import { P2Bold, InputLabel } from '../../../../../Common/DesignSystem/Text';
import { DropdownItem, Input } from '../../../../../Common/DesignSystem/Input';
import i18n from '../../../../../../i18n';

export const VehicleSettingsCard = ({ vehicleForm, windowWidth, updateSelect, updateVehicleForm, inputRefs, isCreatingVehicle, formDetails, setStarValue }) => (
	<div className="overlay_header_bordered" style={{marginTop: 16, flexGrow: 0}}>
		<div className="profile-info-container">
			<div style={{flexDirection: 'column', flex: 1, display: 'flex'}}>
				<P2Bold style={{padding: '8px 0px'}}>
					Vehicle Settings
				</P2Bold>
				<GridContainer justifyContent="space-evenly" spacing={windowWidth <= 768 ? 0 : 3} direction="row">
					<GridItem xs={windowWidth <= 768 ? 12 : 6}>
						<div style={{display: 'flex', flexDirection: 'column'}}>
						{formDetails?.oem_id === -9 ?
							<>
								<div className="f1" style={{flexDirection: 'row', marginBottom: 16}}>
									<div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
										<div className="ds-input-outer-container">
											<div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
												<InputLabel>{i18n.t('Tier')}</InputLabel>
											</div>
											<div className="ds-input">
												<Stars star={vehicleForm.star} mutable updateForm={setStarValue} type={"Vehicle"}/>
											</div>
										</div>
									</div>
								</div>
								<div className="f1" style={{flexDirection: 'row'}}>
									<Input
										label="OEM"
										simple_dropdown
										name="oem_id"
										required
										disabled={!isCreatingVehicle}
										value={vehicleForm.oem_id}
										options={[{ value: -1, option: '' }, ...formDetails?.oems]}
										onChange={(e) => {
											updateSelect({name: 'oem_id', value: e.target.value});
										}}
										style={{minWidth: '100%', maxWidth: '100%'}}
									/>
								</div>
							</>
							:   <div className="f1" style={{flexDirection: 'row', marginBottom: 16}}>
									<div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
										<div className="ds-input-outer-container">
											<div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
												<InputLabel>{i18n.t('Tier')}</InputLabel>
											</div>
											<div className="ds-input">
												<Stars star={vehicleForm.star} mutable updateForm={setStarValue} type={"Vehicle"}/>
											</div>
										</div>
									</div>
								</div>
							}
							{vehicleForm.oem_id ? (
								<div className="f1" style={{flexDirection: 'row'}}>
									<Input
										label="Pool"
										dropdown
										required
										name="sh_id"
										readOnly={!isCreatingVehicle}
										value={vehicleForm.sh_id}
										renderDropdownLabel={
											<>
											{formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id) ?
												<div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
													{DivisionIcon(formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id), null, null, null, true)}
													{formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id)?.option}
												</div>
												: vehicleForm.stakeholder ?
												<div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
													{DivisionIcon(vehicleForm.stakeholder, null, null, null, true)}
													{vehicleForm.stakeholder.Company + " - " + vehicleForm.stakeholder.Division}
												</div>
												: null}
											</>
										}
										onChange={(e)=> {updateSelect({name: 'sh_id', value: e.currentTarget.dataset.id})}}>
										{formDetails?.divisions?.length && formDetails.divisions.map((pool) =>
											<DropdownItem label={pool.option} value={pool.value} render_leading_ic={DivisionIcon(pool, null, null, null, true)}/>
										)}
									</Input>
								</div>
							) : (
								<Input label="Pool" placeholder="Please select the OEM" required disabled />
							)}
							{vehicleForm.sh_id ? (
								<div className="f1" style={{flexDirection: 'row'}}>
									<Input
										label="Facility"
										dropdown
										required
										name="vmh_id"
										readOnly={(!(isCreatingVehicle))}
										value={vehicleForm.vmh_id}
										renderDropdownLabel={
											<>
											{formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id) ?
												<div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
													{VCIcon(formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id), null, null, null, true)}
													{formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id)?.option}
												</div>
												: vehicleForm.vmh ?
												<div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
													{VCIcon(vehicleForm.vmh, null, null, null, true)}
													{vehicleForm.vmh.Display_Name + " - " + vehicleForm.vmh.Display_City}
												</div>
												: null
												}
											</>
										}
										onChange={(e)=> {updateSelect({name: 'vmh_id', value: e.currentTarget.dataset.id})}}
									>
										{formDetails?.vmhs?.length && formDetails.vmhs.map((vmh) =>
											<DropdownItem label={vmh.option} value={vmh.value} render_leading_ic={VCIcon(vmh, null, null, null, true)}/>
										)}
									</Input>
								</div>
							) : (
								<Input label="Facility" placeholder="Please select the Pool" required disabled />
							)}
						</div>
					</GridItem>
					<GridItem xs={windowWidth <= 768 ? 12 : 6}>
						<div style={{display: 'flex', flexDirection: 'column'}}>
							<div className="f1" style={{flexDirection: 'row'}}>
								<Input
									label="Warranty Start"
									placeholder="MM-DD-YYYY"
									trailing_ic="Calendar"
									id="vehicle_form_warranty_date"
									datepicker
									name="warranty_date"
									value={vehicleForm.warranty_date == 'Invalid date' ? '' : vehicleForm.warranty_date}
									onChange={updateVehicleForm}
									ref={inputRefs.warrantyDateRef}
								/>
							</div>
							<div className="f1" style={{flexDirection: 'row'}}>
								<Input
									label="Available Date"
									datepicker
									trailing_ic="Calendar"
									required
									placeholder="MM-DD-YYYY"
									id="vehicle_form_available_date"
									name="available_date"
									value={vehicleForm.available_date == 'Invalid date' ? '' : vehicleForm.available_date}
									onChange={updateVehicleForm}
									ref={inputRefs.availableDateRef}
								/>
							</div>
							<div className="f1" style={{flexDirection: 'row'}}>
								<Input
									label="Retire Date"
									datepicker 
									trailing_ic="Calendar"
									placeholder="MM-DD-YYYY"
									id="vehicle_form_retire_date"
									name="retire_date"
									value={vehicleForm.retire_date == 'Invalid date' ? '' : vehicleForm.retire_date}
									onChange={updateVehicleForm}
									ref={inputRefs.retireDateRef}
								/>
							</div>
						</div>
					</GridItem>
				</GridContainer>
			</div>
		</div>
	</div>
);